import { FC } from 'react';

import { LegalClientVersionEntity } from 'api/types/entity';
import { NavigationBreadcrumbsTitles } from 'components';
import { LayoutWithNavigationBreadcrumbs } from 'components/LayoutWithNavigationBreadcrumbs';
import { Form } from 'libs/form/Form';
import { getVersionDate } from 'modules/client/common/helpers';
import { VersionView } from 'modules/client/common/views';

import {
  LegalRepresentativeSections,
  LegalRepresentativeSectionsProps,
} from '../components';
import { LegalRepresentativeFormType } from '../forms/legalRepresentativeForm';

export interface LegalRepresentativeVersionViewProps
  extends LegalRepresentativeSectionsProps {
  breadcrumbsTitles: NavigationBreadcrumbsTitles;
  versions: LegalClientVersionEntity[];
  initialValues?: LegalRepresentativeFormType;
  name: string;
  versionId: string;
  snapshotLoading?: boolean;
  onChangeVersion: (version: LegalClientVersionEntity) => void;
  onCloseVersionHistory: () => void;
}

export const LegalRepresentativeVersionView: FC<
  LegalRepresentativeVersionViewProps
> = ({
  breadcrumbsTitles,
  versions,
  name,
  initialValues,
  snapshotLoading,
  versionId,
  onCloseVersionHistory,
  onChangeVersion,
  ...sectionsProps
}) => (
  <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
    <VersionView
      content={
        initialValues && (
          <Form
            initialReadOnly
            initialShowCopyButton
            initialValues={initialValues}
            onSubmit={() => {}}
          >
            <LegalRepresentativeSections
              hideActivitySection
              countryRiskAt={getVersionDate(versions, versionId)}
              {...sectionsProps}
            />
          </Form>
        )
      }
      loading={snapshotLoading || !initialValues}
      name={name}
      versionId={versionId}
      versions={versions}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  </LayoutWithNavigationBreadcrumbs>
);
